<template>
  <youtube-media-player-cmp
    v-bind="$attrs"
    ref="player"
    class="YoutubeMediaPlayerCmpExtended"
    tabindex="-1"
    v-on="$listeners"
  >
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data" />
    </template>
  </youtube-media-player-cmp>
</template>

<script>
import { YoutubeMediaPlayerCmp } from '@frankhoodbs/lib';

export default {
  name: 'YoutubeMediaPlayerCmpExtended',
  components: { YoutubeMediaPlayerCmp },
  mounted() {
    this.$watch(
      () => this.$refs.player.ready,
      () => {
        this.$refs.player.$refs.$play.setAttribute('aria-label', 'Play video');
        this.$refs.player.$el
          .querySelectorAll('iframe')[0]
          .setAttribute('tabindex', '-1');
        this.$emit('player-ready');
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.YoutubeMediaPlayerCmpExtended {
  --youtube-media-player-play-width: 80px;
  --youtube-media-player-play-height: 80px;
  --youtube-media-player-caption-padding: 24px 0 0;
  --youtube-media-player-play-color: #{rgba($color-white, 0.8)};
  --youtube-media-player-play-hover-color: #{$color-blue-10};

  &.fullPage {
    --youtube-media-player-border-radius: 0;

    ::v-deep .responsive-video {
      width: 100%;
      height: 520px;
      padding-bottom: 0 !important;
      background-position: 50% 50%;

      @include media-breakpoint-up(lg) {
        height: 600px;
      }

      @include media-breakpoint-up(xl) {
        height: 810px;
      }
    }
  }

  ::v-deep .caption {
    @include responsive-typography-properties($font-primary, a-paragraph-2);
  }

  ::v-deep .play {
    &:focus {
      svg {
        border: 2px solid #1c3775;
      }
    }
  }
}
</style>
